import React, { Component } from "react";
import { connect } from "react-redux";
import { BrowserRouter as Router, Route, Redirect, withRouter } from "react-router-dom";
import SideNav, { NavItem, NavText } from '@trendmicro/react-sidenav';

import Informations from './Informations';
import Supervisors from './Supervisors';
import NewsSupervisors from './NewsSupervisors';
import Buses from "./Buses";
import Drivers from "./Drivers";
import Travels from "./Travels";
import Students from "./Students";
import Officers from "./Officers";

import { handleGetUniversity, restoreUniversity } from '../../../../store/actionCreators/university';
import { handleGetAdmins, restoreAdmins } from '../../../../store/actionCreators/admins';
import { restoreTravels } from '../../../../store/actionCreators/travels';
import { restoreBuses } from '../../../../store/actionCreators/buses';
import { restoreStudents } from '../../../../store/actionCreators/students';

class University extends Component {
    state = {
        toggle: window.innerWidth > 960,
    }

    componentDidMount() {
        this.props.dispatch(handleGetUniversity(this.props.match.params.id));
        this.props.dispatch(handleGetAdmins(this.props.match.params.id))
        .then(result => {
            if (result.error && result.error !== null) {
                // this.setState({
                //     getError: {
                //         state: true,
                //         message: result.error.message
                //     }
                // })
            } else {
                // if (this.props.university !== null) {
                //     const { ar_name, email, phone, website, address } = this.props.university;
                //     this.setState({ ar_name, email, phone, website, address })
                // }
            }
        })
    }

    componentWillUnmount() {
        this.props.dispatch(restoreUniversity())
        this.props.dispatch(restoreAdmins())
        this.props.dispatch(restoreTravels())
        this.props.dispatch(restoreBuses())
        this.props.dispatch(restoreStudents())
    }
    
    toggleNav = () => {
        this.setState({ toggle: !this.state.toggle })
    }
    handleOnSelect = () => {
        this.setState({ toggle: window.innerWidth > 960 ? true : false })
    }

    render() {
        // console.log(this.props)
        return (
            <div className="d-flex flex-wrap flex-lg-nowrap w-100">
                <Router>
                    <Route render={({ location, history, match }) => (
                        <React.Fragment>
                            
                                {this.state.toggle
                                    ? <button className="toggle-btn toggle-btn-active" onClick={this.toggleNav}>
                                        <span className="toggle-btn__u1f02"></span>
                                        <span className="toggle-btn__u1f02"></span>
                                        <span className="toggle-btn__u1f02"></span>
                                    </button> : <button className="toggle-btn" onClick={this.toggleNav}>
                                        <span className="toggle-btn__u1f02"></span>
                                        <span className="toggle-btn__u1f02"></span>
                                        <span className="toggle-btn__u1f02"></span>
                                    </button>
                                }
                                
                            <SideNav
                                expanded = {this.state.toggle}
                                onToggle={this.toggleNav}
                                onSelect={(selected) => {
                                    const to = `/dashboard/universities/${this.props.match.params.id}/${selected}`;
                                    if (location.pathname !== to) {
                                        history.push(to);
                                    }
                                    this.handleOnSelect()
                                }}
                                className={this.state.toggle ? "uni-nav text-center" : "uni-nav uni-nav-hidden"}
                            >
                                <div className="text-center py-2 header">
                                    <img className="mb-2" src={this.props.university && this.props.university !== null && this.props.university.logo && this.props.university.logo!==null ? this.props.university.logo : "/images/university-blank.jpg"} alt="logo" width="100" height="100" />
                                    <h5>{this.props.university && this.props.university !== null && this.props.university.ar_name}</h5>
                                </div>
                                {this.state.toggle &&
                                    <SideNav.Nav className="nev-menu">
                                        <NavItem eventKey="info" navitemClassName="nav-item d-flex align-items-center" active={location.pathname.includes("/info")} disabled={location.pathname.includes("/info")}>
                                            <NavText className="nav-text p-2">
                                                <h5 className="mb-0">معلومات الجامعة</h5>
                                            </NavText>
                                        </NavItem>
                                        <NavItem eventKey="supervisors" navitemClassName="nav-item d-flex align-items-center" active={location.pathname.includes("/supervisor")} disabled={location.pathname.includes("/supervisors")}>
                                            <NavText className="nav-text p-2">
                                                <h5 className="mb-0">المشرفون</h5>
                                            </NavText>
                                        </NavItem>
                                        <NavItem eventKey="news-supervisors" navitemClassName="nav-item d-flex align-items-center" active={location.pathname.includes("/news-supervisors")} disabled={location.pathname.includes("/news-supervisors")}>
                                            <NavText className="nav-text p-2">
                                                <h5 className="mb-0">مشرفو الأخبار</h5>
                                            </NavText>
                                        </NavItem>
                                        <NavItem eventKey="buses" navitemClassName="nav-item d-flex align-items-center" active={location.pathname.includes("/buses")} disabled={location.pathname.includes("/buses")}>
                                            <NavText className="nav-text p-2">
                                                <h5 className="mb-0">الحافلات</h5>
                                            </NavText>
                                        </NavItem>
                                        <NavItem eventKey="drivers" navitemClassName="nav-item d-flex align-items-center" active={location.pathname.includes("/drivers")} disabled={location.pathname.includes("/drivers")}>
                                            <NavText className="nav-text p-2">
                                                <h5 className="mb-0">السائقون</h5>
                                            </NavText>
                                        </NavItem>
                                        <NavItem eventKey="travels" navitemClassName="nav-item d-flex align-items-center" active={location.pathname.includes("/travels")} disabled={location.pathname.includes("/travels")}>
                                            <NavText className="nav-text p-2">
                                                <h5 className="mb-0">خطوط النقل</h5>
                                            </NavText>
                                        </NavItem>
                                        <NavItem eventKey="students" navitemClassName="nav-item d-flex align-items-center" active={location.pathname.includes("/students")} disabled={location.pathname.includes("/students")}>
                                            <NavText className="nav-text p-2">
                                                <h5 className="mb-0">الطلبة المشتركين</h5>
                                            </NavText>
                                        </NavItem>
                                        <NavItem eventKey="officers" navitemClassName="nav-item d-flex align-items-center" active={location.pathname.includes("/officers")} disabled={location.pathname.includes("/officers")}>
                                            <NavText className="nav-text p-2">
                                                <h5 className="mb-0">ضباط الارتباط</h5>
                                            </NavText>
                                        </NavItem>
                                    </SideNav.Nav>
                                }
                            </SideNav>
                            <main className="dashboard w-100">
                                <Route path={`${this.props.match.path}/info`} component={props => <Informations />} />
                                {/* <Redirect strict from={`${this.props.match.url}` + '/'} to={this.props.match.url} /> */}
                                <Route path={`${this.props.match.path}/supervisors`} component={props => <Supervisors />} />
                                <Route path={`${this.props.match.path}/news-supervisors`} component={props => <NewsSupervisors />} />
                                <Route path={`${this.props.match.path}/buses`} component={props => <Buses />} />
                                <Route path={`${this.props.match.path}/drivers`} component={props => <Drivers />} />
                                <Route path={`${this.props.match.path}/travels`} component={props => <Travels />} />
                                <Route path={`${this.props.match.path}/students`} component={props => <Students />} />
                                <Route path={`${this.props.match.path}/officers`} component={props => <Officers />} />
                                <Route exact path={this.props.match.url} render={() => <Redirect to={`${this.props.match.url}/info`} />} />
                            </main>
                        </React.Fragment>
                    )}
                    />
                </Router>
            </div>
        )
    }
}

function mapStateToProps ({ university }) {
	return {
		university
	}
}

export default withRouter(connect(mapStateToProps)(University));